module.exports = __webpack_public_path__ + "static/media/background-johanna-montoya-unsplash.fb1f9bcf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/background-johanna-montoya-unsplash.jpg
// module id = 1744
// module chunks = 0